var map = {
	"./arrows/default": 57,
	"./arrows/default.svg": 57,
	"./arrows/down": 58,
	"./arrows/down-short": 59,
	"./arrows/down-short.svg": 59,
	"./arrows/down.svg": 58,
	"./arrows/long": 60,
	"./arrows/long-white": 61,
	"./arrows/long-white.svg": 61,
	"./arrows/long.svg": 60,
	"./arrows/right": 62,
	"./arrows/right.svg": 62,
	"./arrows/tail-spin": 63,
	"./arrows/tail-spin.svg": 63,
	"./bg/flag": 64,
	"./bg/flag.png": 64,
	"./bg/group-course": 65,
	"./bg/group-course-wave": 66,
	"./bg/group-course-wave-pink": 67,
	"./bg/group-course-wave-pink.svg": 67,
	"./bg/group-course-wave.svg": 66,
	"./bg/group-course.svg": 65,
	"./bg/headers/bamboo-forest-left": 68,
	"./bg/headers/bamboo-forest-left.png": 68,
	"./bg/headers/bamboo-forest-right": 69,
	"./bg/headers/bamboo-forest-right.png": 69,
	"./bg/headers/course": 70,
	"./bg/headers/course.jpg": 70,
	"./bg/headers/geta": 71,
	"./bg/headers/geta.png": 71,
	"./bg/headers/gold-fish": 72,
	"./bg/headers/gold-fish.png": 72,
	"./bg/headers/meal": 73,
	"./bg/headers/meal.png": 73,
	"./bg/headers/origami": 74,
	"./bg/headers/origami.png": 74,
	"./bg/headers/pricing": 75,
	"./bg/headers/pricing.png": 75,
	"./bg/headers/registration": 76,
	"./bg/headers/registration.jpg": 76,
	"./bg/headers/sumo": 77,
	"./bg/headers/sumo.png": 77,
	"./bg/headers/test": 78,
	"./bg/headers/test.jpg": 78,
	"./bg/headers/testimonials": 79,
	"./bg/headers/testimonials.svg": 79,
	"./bg/headers/video-course": 80,
	"./bg/headers/video-course.svg": 80,
	"./bg/hero": 1,
	"./bg/hero.jpg": 357,
	"./bg/hero.svg": 1,
	"./bg/mosaic": 81,
	"./bg/mosaic.png": 81,
	"./bg/mosaic/ab1": 82,
	"./bg/mosaic/ab1.jpg": 82,
	"./bg/mosaic/ab2": 83,
	"./bg/mosaic/ab2.jpg": 83,
	"./bg/mosaic/brushes": 84,
	"./bg/mosaic/brushes.svg": 84,
	"./bg/mosaic/calligraphy": 85,
	"./bg/mosaic/calligraphy.jpg": 85,
	"./bg/mosaic/camp": 86,
	"./bg/mosaic/camp-2": 87,
	"./bg/mosaic/camp-2.jpg": 87,
	"./bg/mosaic/camp.jpg": 86,
	"./bg/mosaic/circle": 88,
	"./bg/mosaic/circle.svg": 88,
	"./bg/mosaic/cloud": 89,
	"./bg/mosaic/cloud-lightblue": 90,
	"./bg/mosaic/cloud-lightblue.svg": 90,
	"./bg/mosaic/cloud-red": 91,
	"./bg/mosaic/cloud-red.svg": 91,
	"./bg/mosaic/cloud.svg": 89,
	"./bg/mosaic/concert": 92,
	"./bg/mosaic/concert.jpg": 92,
	"./bg/mosaic/conversation": 93,
	"./bg/mosaic/conversation.svg": 93,
	"./bg/mosaic/dinner": 94,
	"./bg/mosaic/dinner.jpg": 94,
	"./bg/mosaic/doki-doki": 95,
	"./bg/mosaic/doki-doki.jpg": 95,
	"./bg/mosaic/drum": 96,
	"./bg/mosaic/drum.jpg": 96,
	"./bg/mosaic/hanami": 97,
	"./bg/mosaic/hanami.jpg": 97,
	"./bg/mosaic/hidden-message": 98,
	"./bg/mosaic/hidden-message.svg": 98,
	"./bg/mosaic/kimono": 99,
	"./bg/mosaic/kimono.svg": 99,
	"./bg/mosaic/koi": 100,
	"./bg/mosaic/koi.svg": 100,
	"./bg/mosaic/lector": 101,
	"./bg/mosaic/lector.jpg": 101,
	"./bg/mosaic/lesson": 102,
	"./bg/mosaic/lesson.jpg": 102,
	"./bg/mosaic/monika": 103,
	"./bg/mosaic/monika.jpg": 103,
	"./bg/mosaic/monitor": 104,
	"./bg/mosaic/monitor.svg": 104,
	"./bg/mosaic/ninja": 105,
	"./bg/mosaic/ninja.jpg": 105,
	"./bg/mosaic/origami": 106,
	"./bg/mosaic/origami-lightblue": 107,
	"./bg/mosaic/origami-lightblue.svg": 107,
	"./bg/mosaic/origami.svg": 106,
	"./bg/mosaic/oyakata": 108,
	"./bg/mosaic/oyakata.svg": 108,
	"./bg/mosaic/pattern-arrows": 109,
	"./bg/mosaic/pattern-arrows-light-blue": 110,
	"./bg/mosaic/pattern-arrows-light-blue.svg": 110,
	"./bg/mosaic/pattern-arrows-red": 111,
	"./bg/mosaic/pattern-arrows-red.svg": 111,
	"./bg/mosaic/pattern-arrows.svg": 109,
	"./bg/mosaic/pattern-circles": 112,
	"./bg/mosaic/pattern-circles-bigger": 113,
	"./bg/mosaic/pattern-circles-bigger.svg": 113,
	"./bg/mosaic/pattern-circles.svg": 112,
	"./bg/mosaic/pattern-daisy": 114,
	"./bg/mosaic/pattern-daisy-pink": 115,
	"./bg/mosaic/pattern-daisy-pink.svg": 115,
	"./bg/mosaic/pattern-daisy.svg": 114,
	"./bg/mosaic/pattern-flowers": 116,
	"./bg/mosaic/pattern-flowers.svg": 116,
	"./bg/mosaic/pattern-hexagon": 117,
	"./bg/mosaic/pattern-hexagon.svg": 117,
	"./bg/mosaic/pattern-hills": 118,
	"./bg/mosaic/pattern-hills.svg": 118,
	"./bg/mosaic/pattern-husk": 119,
	"./bg/mosaic/pattern-husk-blue": 120,
	"./bg/mosaic/pattern-husk-blue.svg": 120,
	"./bg/mosaic/pattern-husk-saphire": 121,
	"./bg/mosaic/pattern-husk-saphire.svg": 121,
	"./bg/mosaic/pattern-husk.svg": 119,
	"./bg/mosaic/pattern-triangles": 122,
	"./bg/mosaic/pattern-triangles-red": 123,
	"./bg/mosaic/pattern-triangles-red.svg": 123,
	"./bg/mosaic/pattern-triangles.svg": 122,
	"./bg/mosaic/pattern-wave": 124,
	"./bg/mosaic/pattern-wave.svg": 124,
	"./bg/mosaic/pattern-zigzag": 125,
	"./bg/mosaic/pattern-zigzag-light-blue": 126,
	"./bg/mosaic/pattern-zigzag-light-blue.svg": 126,
	"./bg/mosaic/pattern-zigzag.svg": 125,
	"./bg/mosaic/performance": 127,
	"./bg/mosaic/performance.jpg": 127,
	"./bg/mosaic/sakura": 128,
	"./bg/mosaic/sakura.svg": 128,
	"./bg/mosaic/sencha": 129,
	"./bg/mosaic/sencha.jpg": 129,
	"./bg/mosaic/shodo": 130,
	"./bg/mosaic/shodo-lesson": 131,
	"./bg/mosaic/shodo-lesson.jpg": 131,
	"./bg/mosaic/shodo.jpg": 130,
	"./bg/mosaic/sun": 132,
	"./bg/mosaic/sun.svg": 132,
	"./bg/mosaic/team": 133,
	"./bg/mosaic/team.jpg": 133,
	"./bg/mosaic/temple": 134,
	"./bg/mosaic/temple.svg": 134,
	"./bg/mosaic/workshops": 135,
	"./bg/mosaic/workshops.jpg": 135,
	"./bg/pattern": 136,
	"./bg/pattern.svg": 136,
	"./bg/patterns/activities/1": 137,
	"./bg/patterns/activities/1.svg": 137,
	"./bg/patterns/activities/2": 138,
	"./bg/patterns/activities/2.svg": 138,
	"./bg/patterns/activities/3": 139,
	"./bg/patterns/activities/3.svg": 139,
	"./bg/patterns/activities/4": 140,
	"./bg/patterns/activities/4.svg": 140,
	"./bg/patterns/activities/5": 141,
	"./bg/patterns/activities/5.svg": 141,
	"./bg/patterns/blog": 142,
	"./bg/patterns/blog.svg": 142,
	"./bg/patterns/chessboard": 143,
	"./bg/patterns/chessboard.svg": 143,
	"./bg/patterns/clouds": 144,
	"./bg/patterns/clouds.svg": 144,
	"./bg/patterns/ellipse": 145,
	"./bg/patterns/ellipse.svg": 145,
	"./bg/patterns/husk": 146,
	"./bg/patterns/husk.svg": 146,
	"./bg/patterns/materials": 147,
	"./bg/patterns/materials.svg": 147,
	"./bg/patterns/mosaic": 148,
	"./bg/patterns/mosaic.svg": 148,
	"./bg/patterns/pixels": 149,
	"./bg/patterns/pixels.svg": 149,
	"./bg/patterns/shape-blue": 150,
	"./bg/patterns/shape-blue.svg": 150,
	"./bg/patterns/squares": 151,
	"./bg/patterns/squares.svg": 151,
	"./bg/patterns/triangles": 152,
	"./bg/patterns/triangles-light": 153,
	"./bg/patterns/triangles-light.svg": 153,
	"./bg/patterns/triangles.svg": 152,
	"./bg/shapes/circle": 154,
	"./bg/shapes/circle.svg": 154,
	"./bg/shapes/cloud-1": 155,
	"./bg/shapes/cloud-1.svg": 155,
	"./bg/shapes/cloud-2": 156,
	"./bg/shapes/cloud-2.svg": 156,
	"./bg/shapes/cloud-blue": 157,
	"./bg/shapes/cloud-blue.svg": 157,
	"./bg/shapes/cloud-lightblue": 158,
	"./bg/shapes/cloud-lightblue.svg": 158,
	"./bg/shapes/cloud-red": 159,
	"./bg/shapes/cloud-red.svg": 159,
	"./bg/shapes/cube": 160,
	"./bg/shapes/cube.svg": 160,
	"./bg/shapes/ecru/1": 161,
	"./bg/shapes/ecru/1.svg": 161,
	"./bg/shapes/ecru/2": 162,
	"./bg/shapes/ecru/2.svg": 162,
	"./bg/shapes/ecru/3": 163,
	"./bg/shapes/ecru/3.svg": 163,
	"./bg/shapes/ecru/4": 164,
	"./bg/shapes/ecru/4.svg": 164,
	"./bg/shapes/gallery/activities": 165,
	"./bg/shapes/gallery/activities.svg": 165,
	"./bg/shapes/gallery/party": 166,
	"./bg/shapes/gallery/party.svg": 166,
	"./bg/shapes/gallery/trips": 167,
	"./bg/shapes/gallery/trips.svg": 167,
	"./bg/shapes/husk": 168,
	"./bg/shapes/husk.svg": 168,
	"./bg/shapes/triangles": 169,
	"./bg/shapes/triangles.svg": 169,
	"./icons/check": 170,
	"./icons/check-green": 171,
	"./icons/check-green.svg": 171,
	"./icons/check-light": 172,
	"./icons/check-light.svg": 172,
	"./icons/check-white": 173,
	"./icons/check-white.svg": 173,
	"./icons/check.svg": 170,
	"./icons/close": 174,
	"./icons/close.svg": 174,
	"./icons/cookies": 175,
	"./icons/cookies.svg": 175,
	"./icons/cross": 176,
	"./icons/cross.svg": 176,
	"./icons/dot": 177,
	"./icons/dot.svg": 177,
	"./icons/enroll": 178,
	"./icons/enroll.svg": 178,
	"./icons/envelope": 179,
	"./icons/envelope.svg": 179,
	"./icons/facebook": 180,
	"./icons/facebook-w": 181,
	"./icons/facebook-w.svg": 181,
	"./icons/facebook.svg": 180,
	"./icons/fb": 182,
	"./icons/fb.svg": 182,
	"./icons/flag-en": 183,
	"./icons/flag-en.svg": 183,
	"./icons/flag-jp": 184,
	"./icons/flag-jp.svg": 184,
	"./icons/flag-pl": 185,
	"./icons/flag-pl.svg": 185,
	"./icons/gift": 186,
	"./icons/gift.svg": 186,
	"./icons/instagram": 187,
	"./icons/instagram-w": 188,
	"./icons/instagram-w.svg": 188,
	"./icons/instagram.svg": 187,
	"./icons/keyboard": 189,
	"./icons/keyboard.svg": 189,
	"./icons/linkedin": 190,
	"./icons/linkedin.svg": 190,
	"./icons/marker": 2,
	"./icons/marker.png": 2,
	"./icons/marker.svg": 358,
	"./icons/mobile": 191,
	"./icons/mobile.svg": 191,
	"./icons/price": 192,
	"./icons/price-blue": 193,
	"./icons/price-blue.svg": 193,
	"./icons/price-green": 194,
	"./icons/price-green.svg": 194,
	"./icons/price-pink": 195,
	"./icons/price-pink.svg": 195,
	"./icons/price.svg": 192,
	"./icons/quote": 196,
	"./icons/quote-big": 197,
	"./icons/quote-big.svg": 197,
	"./icons/quote.svg": 196,
	"./icons/star-1-blue": 198,
	"./icons/star-1-blue.svg": 198,
	"./icons/star-1-red": 199,
	"./icons/star-1-red.svg": 199,
	"./icons/star-3-blue": 200,
	"./icons/star-3-blue.svg": 200,
	"./icons/star-3-red": 201,
	"./icons/star-3-red.svg": 201,
	"./icons/tag-blue": 202,
	"./icons/tag-blue.svg": 202,
	"./icons/tag-red": 203,
	"./icons/tag-red.svg": 203,
	"./icons/twitter": 204,
	"./icons/twitter.svg": 204,
	"./icons/youtube": 205,
	"./icons/youtube.svg": 205,
	"./icons/zoom": 206,
	"./icons/zoom.svg": 206,
	"./logo": 207,
	"./logo-mobile": 208,
	"./logo-mobile.svg": 208,
	"./logo.svg": 207,
	"./media/images/pic/teachers/anna-sielawko": 3,
	"./media/images/pic/teachers/anna-sielawko.png": 3,
	"./media/images/pic/teachers/anna-sielawko.webp": 359,
	"./media/images/pic/teachers/joanna-shimada": 4,
	"./media/images/pic/teachers/joanna-shimada.png": 4,
	"./media/images/pic/teachers/joanna-shimada.webp": 360,
	"./media/images/pic/teachers/kaede-funakoshi": 5,
	"./media/images/pic/teachers/kaede-funakoshi.png": 5,
	"./media/images/pic/teachers/kaede-funakoshi.webp": 361,
	"./media/images/pic/teachers/krzysztof-walaszek": 6,
	"./media/images/pic/teachers/krzysztof-walaszek.png": 6,
	"./media/images/pic/teachers/krzysztof-walaszek.webp": 362,
	"./media/images/pic/teachers/magdalena-kisly": 7,
	"./media/images/pic/teachers/magdalena-kisly.png": 7,
	"./media/images/pic/teachers/magdalena-kisly.webp": 363,
	"./media/images/pic/teachers/wiktoria-piontek": 8,
	"./media/images/pic/teachers/wiktoria-piontek.png": 8,
	"./media/images/pic/teachers/wiktoria-piontek.webp": 364,
	"./pic/activities/sakaki": 209,
	"./pic/activities/sakaki.png": 209,
	"./pic/activities/shizuoka": 210,
	"./pic/activities/shizuoka.png": 210,
	"./pic/activities/tokio": 211,
	"./pic/activities/tokio.png": 211,
	"./pic/advantage": 212,
	"./pic/advantage-mobile": 213,
	"./pic/advantage-mobile.png": 213,
	"./pic/advantage.png": 212,
	"./pic/authors/agata-krukowska": 214,
	"./pic/authors/agata-krukowska.png": 214,
	"./pic/authors/marta-klimiuk": 215,
	"./pic/authors/marta-klimiuk.png": 215,
	"./pic/authors/monika-zachaj": 216,
	"./pic/authors/monika-zachaj.png": 216,
	"./pic/blank/226x183": 217,
	"./pic/blank/226x183.jpg": 217,
	"./pic/bunkasai": 218,
	"./pic/bunkasai.jpg": 218,
	"./pic/compare/after": 219,
	"./pic/compare/after.jpg": 219,
	"./pic/compare/before": 220,
	"./pic/compare/before.jpg": 220,
	"./pic/compare/old/after": 221,
	"./pic/compare/old/after.jpg": 221,
	"./pic/compare/old/before": 222,
	"./pic/compare/old/before.jpg": 222,
	"./pic/contact": 223,
	"./pic/contact.svg": 223,
	"./pic/courses/00": 224,
	"./pic/courses/00.svg": 224,
	"./pic/courses/01": 225,
	"./pic/courses/01.svg": 225,
	"./pic/courses/02": 226,
	"./pic/courses/02.svg": 226,
	"./pic/courses/advanced-level": 227,
	"./pic/courses/advanced-level.png": 227,
	"./pic/courses/beginner-level": 228,
	"./pic/courses/beginner-level.png": 228,
	"./pic/courses/benefit01": 229,
	"./pic/courses/benefit01.svg": 229,
	"./pic/courses/benefit02": 230,
	"./pic/courses/benefit02.svg": 230,
	"./pic/courses/benefit03": 231,
	"./pic/courses/benefit03.svg": 231,
	"./pic/courses/benefit04": 232,
	"./pic/courses/benefit04.svg": 232,
	"./pic/courses/benefit05": 233,
	"./pic/courses/benefit05.svg": 233,
	"./pic/courses/benefit06": 234,
	"./pic/courses/benefit06.svg": 234,
	"./pic/courses/benefit07": 235,
	"./pic/courses/benefit07.svg": 235,
	"./pic/courses/benefit08": 236,
	"./pic/courses/benefit08.svg": 236,
	"./pic/courses/group-banner": 9,
	"./pic/courses/group-banner.png": 9,
	"./pic/courses/group-banner.webp": 365,
	"./pic/courses/group-teacher-left": 237,
	"./pic/courses/group-teacher-left.png": 237,
	"./pic/courses/group-teacher-right": 238,
	"./pic/courses/group-teacher-right.png": 238,
	"./pic/courses/intensity-beginner": 239,
	"./pic/courses/intensity-beginner.svg": 239,
	"./pic/courses/intensity-intensive": 240,
	"./pic/courses/intensity-intensive.svg": 240,
	"./pic/courses/intensity-standard": 241,
	"./pic/courses/intensity-standard.svg": 241,
	"./pic/courses/intermediate-level": 242,
	"./pic/courses/intermediate-level.png": 242,
	"./pic/courses/monika-zachaj": 243,
	"./pic/courses/monika-zachaj.png": 243,
	"./pic/courses/pakiet-startowy": 244,
	"./pic/courses/pakiet-startowy.png": 244,
	"./pic/courses/ryotaro-sakamoto": 245,
	"./pic/courses/ryotaro-sakamoto.png": 245,
	"./pic/courses/ryotaro-sakamoto2": 246,
	"./pic/courses/ryotaro-sakamoto2.png": 246,
	"./pic/courses/sun": 247,
	"./pic/courses/sun.svg": 247,
	"./pic/courses/zestaw-powitalny-gratis": 248,
	"./pic/courses/zestaw-powitalny-gratis.png": 248,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii": 249,
	"./pic/gallery/2017/japan-bowl-turniej-o-puchar-japonii.jpg": 249,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii": 250,
	"./pic/gallery/2017/matsuri-piknik-z-kultura-japonii.jpg": 250,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii": 251,
	"./pic/gallery/2018/japan-bowl-turniej-o-puchar-japonii.jpg": 251,
	"./pic/gallery/2018/szkola-letnia": 252,
	"./pic/gallery/2018/szkola-letnia.jpg": 252,
	"./pic/gallery/2018/warsztaty-chust-furoshiki": 253,
	"./pic/gallery/2018/warsztaty-chust-furoshiki.jpg": 253,
	"./pic/gallery/2018/warsztaty-ehomaki": 254,
	"./pic/gallery/2018/warsztaty-ehomaki.jpg": 254,
	"./pic/gallery/2018/warsztaty-herbaty-sencha": 255,
	"./pic/gallery/2018/warsztaty-herbaty-sencha.jpg": 255,
	"./pic/gallery/2018/warsztaty-kawaii-sushi": 256,
	"./pic/gallery/2018/warsztaty-kawaii-sushi.jpg": 256,
	"./pic/gallery/2019/impreza-bonenkai": 257,
	"./pic/gallery/2019/impreza-bonenkai.jpg": 257,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii": 258,
	"./pic/gallery/2019/matsuri-piknik-z-kultura-japonii.jpg": 258,
	"./pic/gallery/2019/szkola-letnia": 259,
	"./pic/gallery/2019/szkola-letnia.jpg": 259,
	"./pic/gallery/2019/warsztaty-obento": 260,
	"./pic/gallery/2019/warsztaty-obento.jpg": 260,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi": 261,
	"./pic/gallery/2019/warsztaty-slodyczy-wagashi.jpg": 261,
	"./pic/gallery/2020/ceremonia-herbaty": 262,
	"./pic/gallery/2020/ceremonia-herbaty.jpg": 262,
	"./pic/godzilla": 0,
	"./pic/godzilla-mobile": 10,
	"./pic/godzilla-mobile.png": 10,
	"./pic/godzilla-mobile.webp": 366,
	"./pic/godzilla.png": 0,
	"./pic/godzilla.svg": 367,
	"./pic/godzilla.webp": 368,
	"./pic/godzilla/beast": 263,
	"./pic/godzilla/beast.png": 263,
	"./pic/godzilla/pattern": 264,
	"./pic/godzilla/pattern.svg": 264,
	"./pic/google-rating": 265,
	"./pic/google-rating.svg": 265,
	"./pic/hero/all": 266,
	"./pic/hero/all.png": 266,
	"./pic/hero/clouds": 11,
	"./pic/hero/clouds.png": 11,
	"./pic/hero/clouds.webp": 369,
	"./pic/hero/desc": 267,
	"./pic/hero/desc.svg": 267,
	"./pic/hero/land": 12,
	"./pic/hero/land.png": 12,
	"./pic/hero/land.webp": 370,
	"./pic/hero/mobile": 13,
	"./pic/hero/mobile.jpg": 13,
	"./pic/hero/mobile.webp": 371,
	"./pic/hero/mountain": 14,
	"./pic/hero/mountain.png": 14,
	"./pic/hero/mountain.webp": 372,
	"./pic/hero/sea": 15,
	"./pic/hero/sea.png": 15,
	"./pic/hero/sea.webp": 373,
	"./pic/hero/stats-wave": 16,
	"./pic/hero/stats-wave.png": 16,
	"./pic/hero/stats-wave.webp": 374,
	"./pic/hero/sun": 17,
	"./pic/hero/sun.png": 17,
	"./pic/hero/sun.webp": 375,
	"./pic/hero/trees": 18,
	"./pic/hero/trees.png": 18,
	"./pic/hero/trees.webp": 376,
	"./pic/hero/video-bottom": 268,
	"./pic/hero/video-bottom.svg": 268,
	"./pic/hero/video-top": 269,
	"./pic/hero/video-top.svg": 269,
	"./pic/hero/waves": 19,
	"./pic/hero/waves.png": 19,
	"./pic/hero/waves.webp": 377,
	"./pic/home/1": 270,
	"./pic/home/1.svg": 270,
	"./pic/home/all": 271,
	"./pic/home/all.png": 271,
	"./pic/home/book-waku-waku": 20,
	"./pic/home/book-waku-waku.png": 20,
	"./pic/home/book-waku-waku.webp": 378,
	"./pic/home/owners": 21,
	"./pic/home/owners.png": 21,
	"./pic/home/owners.svg": 379,
	"./pic/home/pride": 22,
	"./pic/home/pride-cloud": 272,
	"./pic/home/pride-cloud.svg": 272,
	"./pic/home/pride-pattern": 273,
	"./pic/home/pride-pattern.svg": 273,
	"./pic/home/pride.png": 22,
	"./pic/home/pride.webp": 380,
	"./pic/home/video-course-preview": 274,
	"./pic/home/video-course-preview.png": 274,
	"./pic/home/video-courses": 275,
	"./pic/home/video-courses.png": 275,
	"./pic/keyboard": 276,
	"./pic/keyboard.svg": 276,
	"./pic/kitty-group": 277,
	"./pic/kitty-group-light": 278,
	"./pic/kitty-group-light.png": 278,
	"./pic/kitty-group.png": 277,
	"./pic/kitty-individual": 279,
	"./pic/kitty-individual.png": 279,
	"./pic/labels/a1_1": 280,
	"./pic/labels/a1_1.png": 280,
	"./pic/labels/a1_1b": 281,
	"./pic/labels/a1_1b.png": 281,
	"./pic/labels/a1_2": 282,
	"./pic/labels/a1_2.png": 282,
	"./pic/labels/a1_2a": 283,
	"./pic/labels/a1_2a.png": 283,
	"./pic/labels/a2_1": 284,
	"./pic/labels/a2_1.png": 284,
	"./pic/labels/a2_1b": 285,
	"./pic/labels/a2_1b.png": 285,
	"./pic/labels/a2_2": 286,
	"./pic/labels/a2_2.png": 286,
	"./pic/labels/a2_2a": 287,
	"./pic/labels/a2_2a.png": 287,
	"./pic/labels/a2_2b": 288,
	"./pic/labels/a2_2b.png": 288,
	"./pic/labels/b1_1": 289,
	"./pic/labels/b1_1.png": 289,
	"./pic/labels/b1_1b": 290,
	"./pic/labels/b1_1b.png": 290,
	"./pic/labels/b1_2": 291,
	"./pic/labels/b1_2.png": 291,
	"./pic/labels/b2_1": 292,
	"./pic/labels/b2_1.png": 292,
	"./pic/labels/b2_2": 293,
	"./pic/labels/b2_2.png": 293,
	"./pic/labels/c1_1": 294,
	"./pic/labels/c1_1.png": 294,
	"./pic/labels/c1_2": 295,
	"./pic/labels/c1_2.png": 295,
	"./pic/labels/c2_2": 296,
	"./pic/labels/c2_2.png": 296,
	"./pic/labels/materials/doki-doki-1": 297,
	"./pic/labels/materials/doki-doki-1.jpg": 297,
	"./pic/labels/materials/doki-doki-2": 298,
	"./pic/labels/materials/doki-doki-2.jpg": 298,
	"./pic/labels/materials/doki-doki-3": 299,
	"./pic/labels/materials/doki-doki-3.jpg": 299,
	"./pic/labels/materials/pera-pera-1": 300,
	"./pic/labels/materials/pera-pera-1.jpg": 300,
	"./pic/labels/materials/pera-pera-2": 301,
	"./pic/labels/materials/pera-pera-2.jpg": 301,
	"./pic/labels/materials/pera-pera-3": 302,
	"./pic/labels/materials/pera-pera-3.jpg": 302,
	"./pic/labels/materials/waku-waku-1": 303,
	"./pic/labels/materials/waku-waku-1.jpg": 303,
	"./pic/labels/materials/waku-waku-2": 304,
	"./pic/labels/materials/waku-waku-2.jpg": 304,
	"./pic/labels/materials/waku-waku-3": 305,
	"./pic/labels/materials/waku-waku-3.jpg": 305,
	"./pic/magazine": 306,
	"./pic/magazine.png": 306,
	"./pic/materials/100-lecie-przyjazni": 307,
	"./pic/materials/100-lecie-przyjazni.png": 307,
	"./pic/materials/hiragana": 308,
	"./pic/materials/hiragana.png": 308,
	"./pic/materials/katakana": 309,
	"./pic/materials/katakana.png": 309,
	"./pic/news-main": 310,
	"./pic/news-main.jpg": 310,
	"./pic/newsletter": 23,
	"./pic/newsletter.png": 23,
	"./pic/newsletter.svg": 381,
	"./pic/owners": 24,
	"./pic/owners.png": 24,
	"./pic/owners.webp": 382,
	"./pic/popup/icon-book": 311,
	"./pic/popup/icon-book.png": 311,
	"./pic/popup/icon-flags": 312,
	"./pic/popup/icon-flags.png": 312,
	"./pic/popup/icon-group": 313,
	"./pic/popup/icon-group.png": 313,
	"./pic/popup/icon-video": 314,
	"./pic/popup/icon-video.png": 314,
	"./pic/popup/popup-desktop-bg": 315,
	"./pic/popup/popup-desktop-bg.png": 315,
	"./pic/popup/popup-desktop-final": 316,
	"./pic/popup/popup-desktop-final.jpg": 316,
	"./pic/popup/popup-desktop-icons": 317,
	"./pic/popup/popup-desktop-icons.png": 317,
	"./pic/popup/popup-mobile-bg": 318,
	"./pic/popup/popup-mobile-bg.jpg": 318,
	"./pic/popup/popup-mobile-icons": 319,
	"./pic/popup/popup-mobile-icons.jpg": 319,
	"./pic/ramen1": 25,
	"./pic/ramen1.png": 25,
	"./pic/ramen1.svg": 383,
	"./pic/teachers/agata-krukowska": 26,
	"./pic/teachers/agata-krukowska.png": 26,
	"./pic/teachers/agata-krukowska.webp": 384,
	"./pic/teachers/alicja-suska": 27,
	"./pic/teachers/alicja-suska.png": 27,
	"./pic/teachers/alicja-suska.webp": 385,
	"./pic/teachers/animation": 320,
	"./pic/teachers/animation-image": 321,
	"./pic/teachers/animation-image.jpg": 321,
	"./pic/teachers/animation.svg": 320,
	"./pic/teachers/anna-sielawko": 28,
	"./pic/teachers/anna-sielawko.png": 28,
	"./pic/teachers/anna-sielawko.webp": 386,
	"./pic/teachers/hiroko-fujii": 29,
	"./pic/teachers/hiroko-fujii.png": 29,
	"./pic/teachers/hiroko-fujii.webp": 387,
	"./pic/teachers/joanna-shimada": 30,
	"./pic/teachers/joanna-shimada.png": 30,
	"./pic/teachers/joanna-shimada.webp": 388,
	"./pic/teachers/julia-caba": 31,
	"./pic/teachers/julia-caba.png": 31,
	"./pic/teachers/julia-caba.webp": 389,
	"./pic/teachers/kaede-funakoshi": 32,
	"./pic/teachers/kaede-funakoshi.png": 32,
	"./pic/teachers/kaede-funakoshi.webp": 390,
	"./pic/teachers/katarzyna-lesniewska": 33,
	"./pic/teachers/katarzyna-lesniewska.png": 33,
	"./pic/teachers/katarzyna-lesniewska.webp": 391,
	"./pic/teachers/katarzyna-stanko": 34,
	"./pic/teachers/katarzyna-stanko.png": 34,
	"./pic/teachers/katarzyna-stanko.webp": 392,
	"./pic/teachers/krzysztof-walaszek": 35,
	"./pic/teachers/krzysztof-walaszek.png": 35,
	"./pic/teachers/krzysztof-walaszek.webp": 393,
	"./pic/teachers/magdalena-kisly": 36,
	"./pic/teachers/magdalena-kisly.png": 36,
	"./pic/teachers/magdalena-kisly.webp": 394,
	"./pic/teachers/magdalena-zak": 37,
	"./pic/teachers/magdalena-zak.png": 37,
	"./pic/teachers/magdalena-zak.webp": 395,
	"./pic/teachers/marin-iwai": 38,
	"./pic/teachers/marin-iwai.png": 38,
	"./pic/teachers/marin-iwai.webp": 396,
	"./pic/teachers/marta-klimiuk-nikkarinen": 39,
	"./pic/teachers/marta-klimiuk-nikkarinen.png": 39,
	"./pic/teachers/marta-klimiuk-nikkarinen.webp": 397,
	"./pic/teachers/marta-szulc": 40,
	"./pic/teachers/marta-szulc.png": 40,
	"./pic/teachers/marta-szulc.webp": 398,
	"./pic/teachers/miho-takahashi": 41,
	"./pic/teachers/miho-takahashi.png": 41,
	"./pic/teachers/miho-takahashi.webp": 399,
	"./pic/teachers/monika-zachaj": 42,
	"./pic/teachers/monika-zachaj.png": 42,
	"./pic/teachers/monika-zachaj.webp": 400,
	"./pic/teachers/owner": 322,
	"./pic/teachers/owner.png": 322,
	"./pic/teachers/ryotaro-sakamoto": 43,
	"./pic/teachers/ryotaro-sakamoto.png": 43,
	"./pic/teachers/ryotaro-sakamoto.webp": 401,
	"./pic/teachers/sayaka-nakai": 323,
	"./pic/teachers/sayaka-nakai.webp": 323,
	"./pic/teachers/urszula-hellich": 44,
	"./pic/teachers/urszula-hellich.png": 44,
	"./pic/teachers/urszula-hellich.webp": 402,
	"./pic/teachers/weronika-smorag": 45,
	"./pic/teachers/weronika-smorag.png": 45,
	"./pic/teachers/weronika-smorag.webp": 403,
	"./pic/teachers/wiktoria-piontek": 46,
	"./pic/teachers/wiktoria-piontek.png": 46,
	"./pic/teachers/wiktoria-piontek.webp": 404,
	"./pic/team": 324,
	"./pic/team.jpg": 324,
	"./pic/testimonials/awatar-01": 325,
	"./pic/testimonials/awatar-01.svg": 325,
	"./pic/testimonials/awatar-02": 326,
	"./pic/testimonials/awatar-02.svg": 326,
	"./pic/testimonials/awatar-03": 327,
	"./pic/testimonials/awatar-03.svg": 327,
	"./pic/testimonials/awatar-04": 328,
	"./pic/testimonials/awatar-04.svg": 328,
	"./pic/testimonials/awatar-05": 329,
	"./pic/testimonials/awatar-05.svg": 329,
	"./pic/testimonials/awatar-06": 330,
	"./pic/testimonials/awatar-06.svg": 330,
	"./pic/testimonials/awatar-07": 331,
	"./pic/testimonials/awatar-07.svg": 331,
	"./pic/testimonials/awatar-08": 332,
	"./pic/testimonials/awatar-08.svg": 332,
	"./pic/testimonials/awatar-09": 47,
	"./pic/testimonials/awatar-09.png": 47,
	"./pic/testimonials/awatar-09.svg": 405,
	"./pic/testimonials/awatar-10": 333,
	"./pic/testimonials/awatar-10.svg": 333,
	"./pic/testimonials/awatar-11": 334,
	"./pic/testimonials/awatar-11.svg": 334,
	"./pic/testimonials/awatar-12": 335,
	"./pic/testimonials/awatar-12.svg": 335,
	"./pic/testimonials/blank": 48,
	"./pic/testimonials/blank.jpg": 48,
	"./pic/testimonials/blank.webp": 406,
	"./pic/testimonials/gabrysia": 49,
	"./pic/testimonials/gabrysia.jpg": 49,
	"./pic/testimonials/gabrysia.webp": 407,
	"./pic/testimonials/klaudia": 50,
	"./pic/testimonials/klaudia.jpg": 50,
	"./pic/testimonials/klaudia.webp": 408,
	"./pic/testimonials/kuba": 51,
	"./pic/testimonials/kuba.jpg": 51,
	"./pic/testimonials/kuba.webp": 409,
	"./pic/testimonials/monika": 52,
	"./pic/testimonials/monika.jpg": 52,
	"./pic/testimonials/monika.webp": 410,
	"./pic/testimonials/naza": 53,
	"./pic/testimonials/naza.jpg": 53,
	"./pic/testimonials/naza.webp": 411,
	"./pic/testimonials/patti": 54,
	"./pic/testimonials/patti.jpg": 54,
	"./pic/testimonials/patti.webp": 412,
	"./pic/testimonials/wiktoria": 55,
	"./pic/testimonials/wiktoria.jpg": 55,
	"./pic/testimonials/wiktoria.webp": 413,
	"./pic/timeline": 336,
	"./pic/timeline.jpg": 336,
	"./pic/timeline/2011": 337,
	"./pic/timeline/2011.jpg": 337,
	"./pic/timeline/2013": 338,
	"./pic/timeline/2013.jpg": 338,
	"./pic/timeline/2014": 339,
	"./pic/timeline/2014.jpg": 339,
	"./pic/timeline/2016": 340,
	"./pic/timeline/2016.jpg": 340,
	"./pic/timeline/2017": 341,
	"./pic/timeline/2017.jpg": 341,
	"./pic/timeline/2018": 342,
	"./pic/timeline/2018.jpg": 342,
	"./pic/timeline/2019": 343,
	"./pic/timeline/2019.jpg": 343,
	"./pic/timeline/2020": 344,
	"./pic/timeline/2020.jpg": 344,
	"./pic/timeline/2021": 345,
	"./pic/timeline/2021.jpg": 345,
	"./pic/timeline/2022": 346,
	"./pic/timeline/2022.jpg": 346,
	"./pic/timeline/2023": 347,
	"./pic/timeline/2023.jpg": 347,
	"./pic/timeline/2024": 348,
	"./pic/timeline/2024.jpg": 348,
	"./pic/tree": 56,
	"./pic/tree.png": 56,
	"./pic/tree.webp": 414,
	"./pic/umbrella": 349,
	"./pic/umbrella.jpg": 349,
	"./pic/warsaw-card": 350,
	"./pic/warsaw-card.jpg": 350,
	"./pic/wave": 351,
	"./pic/wave.png": 351,
	"./pic/wsjj-team": 352,
	"./pic/wsjj-team-mobile": 353,
	"./pic/wsjj-team-mobile.webp": 353,
	"./pic/wsjj-team.webp": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;